module.exports = __webpack_public_path__ + "static/media/07.5a22f4f5.mp3";